import { showMentionNotification } from "app/actions/notification";
import { AppDispatch } from "app/store";

export function dataHandler(
  dispatch: AppDispatch,
  response: Moim.WebsocketEvent.Notification,
) {
  dispatch(showMentionNotification(response));
}
